import React, { useEffect } from "react";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import DonateComponent from "../components/donation/DonateComponent";
import HeaderComponent from "../common/header/Header";
import { useLocation } from "react-router-dom";
import SEO from "../common/seo/SEO";

const DonateNow = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <SEO path={"/donate-now"} prefix={"Support Us"} />
      <HeaderComponent />
      <Breadcrumb heading="Donate Now" currentPage="Donate Now" />
      <DonateComponent />
      <Footer />
    </>
  );
};

export default DonateNow;
